
$(function()
{
	/**
	 * 公開/下書きの切り替えによるsubmitボタンの切り替え
	 */
	$('[name=status]').on('change', function()
	{
		if(!$(this).prop('checked')) return;
		if(1==$(this).val()) {
			$('button.to-check').show()
			$('button.to-draft').hide()
			// $('form.edit').removeClass('draft')
			$('form.edit').attr('action', $('form.edit').data('action-to-check'))
		} else {
			$('button.to-check').hide()
			$('button.to-draft').show()
			// $('form.edit').addClass('draft')
			$('form.edit').attr('action', $('form.edit').data('action-to-draft'))
		}
	})
	$('[name=status]').trigger('change')

	/**
	 * 公演情報の追加
	 */
	$('#add-place button').on('click', function()
	{
		// 既存の公演情報を複製
		var $place = $('.perform-box').eq(0).clone(true).insertBefore('#add-place')

		// 入力値を空に
		$place.find('[name]').each(function(){
			if($(this).is('[type=checkbox]')) {
				$(this).prop('checked', false)
			} else {
				$(this).val('')
			}
		})

		// CKEditorを再セット
		$place.find('.cke').remove()
		$place.find('[data-ckeditor]').each(function(){
			$(this).removeAttr('style')
			ckeditor_load($(this))
		})

		// 公演日時を１つのみにする
		$place.find('.schedule-box tbody tr').each(function(){
			if($(this).index()) $(this).remove()// 2個目以上は削除してまう
		})

		// 色選択リセット
		$place.find('.ticket-box').find('input, textarea, select').removeClass()
		$place.find('.ticket-box').find('select').addClass('color-selector')
		$place.find('.ticket-box').find('tr.url input').addClass('pure-input-1')

		// 新要素nameに変換
		var new_num = getNewNum(/^_places\[(\d+)\]/)
		$place.find('[name^="places["],[name^="_places["]').each(function(){
			$(this).attr('name', $(this).attr('name').replace(/^_?places\[(\d+)\]/, '_places['+new_num+']'))
		})
	})

	/**
	 * 公演情報の削除
	 */
	$(this).on('click', '.remove-place', function()
	{
		if(1===$('.perform-box').length) {
			alert('これ以上削除できません。')
			return;
		}
		if(!confirm('ご指定の公演情報を削除してもよろしいでしょうか。\n※保存完了するまでは実際のデータには反映されません。')) return;
		$(this).parents('.perform-box').eq(0).animate({opacity: 0, height: 0}, 500, function(){ $(this).remove() })
	})

	/**
	 * 公演日時の追加
	 */
	$('.add-schedule button').on('click', function()
	{
		// 既存の公演日時を複製
		var $scheduleBox = $(this).parents('.perform-box').eq(0).find('table.schedule-box')
		var $schedule = $scheduleBox.find('tbody tr').eq(0).clone(true).insertAfter($scheduleBox.find('tbody tr:last-child').eq(0))

		// 入力値を空に
		$schedule.find('[name]').val('')

		// エラーメッセージは削除
		$schedule.find('.error').remove()

		// 新要素nameに変換
		var new_num = getNewNum(/\[_schedules\]\[(\d+)\]/)
		$schedule.find('[name*="[schedules]["],[name*="[_schedules]["]').each(function(){
			console.log(new_num)
			$(this).attr('name', $(this).attr('name').replace(/\[_?schedules\]\[(\d+)\]/, '[_schedules]['+new_num+']'))
		})
	})

	/**
	 * 公演日時の削除
	 */
	$(this).on('click', '.remove-schedule', function()
	{
		var $performBox = $(this).parents('.perform-box').eq(0)
		if(1===$performBox.find('table.schedule-box tbody tr').length) {
			alert('これ以上削除できません。')
			return;
		}
		if(!confirm('ご指定の公演日時を削除してもよろしいでしょうか。\n※保存完了するまでは実際のデータには反映されません。')) return;
		$(this).parents('.schedule-box tr').eq(0).animate({opacity: 0}, 300, function(){ $(this).remove() })
	})

	/**
	 * 色選択
	 */
	var update_color_selector = function($selector){
		var inputs = $selector.parent('td').find('input,textarea');
		inputs.removeClass()
		$selector.removeClass().addClass('color-selector')
		if($selector.val()) {
			inputs.addClass('text-'+$selector.val())
			$selector.addClass('text-'+$selector.val())
		}
	};
	$(this).on('change', '.color-selector', function(){
		update_color_selector($(this))
	})
	$('.color-selector').trigger('change')
});

/**
 * 正規表現で指定したname要素の数字部分を全て探して最大値に+1して返す
 */
function getNewNum(regex) {
	var max = 0
	$('[name]').each(function(){
		var matches = $(this).attr('name').match(regex)
		if(matches && matches[1].length && max < parseInt(matches[1])) max = parseInt(matches[1])
	})
	return max+1
}
